import React, { Component } from 'react'

import axios from 'axios/index'
import { withRouter } from 'react-router-dom'
import swal from 'sweetalert2'

import urls from '../../../../../utils/urls'
import { ajaxHandler } from '../../../../../utils/errors'
import { tokenHeader } from '../../../../../utils/headers'
import translator from '../../../../../utils/translations'
import helpers from '../../../../../utils/helpers';

class DischargeMeterSelection extends Component {

    constructor (props) {
        super(props);

        let meter = props.meters.length === 1 ? props.meters[0].id : '';

        this.state = {
            canEdit: true, //helpers.isUserProvider(this.props.user),
            ajaxInProgress: false,
            trip: props.trip,
            meters: props.meters,
            discharge: props.discharge,
            edited: false,

            // Fields
            meter
        }
    }

    componentDidMount(){
        window.initializeCollapsible();
        window.initializeSelects('body');
        window.bindSelectAction(this.meterSelect, this._handleSelectChange);
    }

    _handleSelectChange = (ev) => {
        let target = ev.target;
        this.setState({
            [target.getAttribute('data-state-var')]: target.value,
            edited: true
        });
    };

    _handleInput = (prop, value) => {

        // Custom validations

        this.setState({[prop]: value})
    };

    _submitForm = () => {
        this.setState({ajaxInProgress: true})

        let {meter} = this.state;

        let data = {meter};

        const DISCHARGE_URL = `${urls.API_ROOT}/api/v1/discharge/id/${this.state.discharge.id}/`;
        axios.put(`${DISCHARGE_URL}`, data, tokenHeader())
            .then(this._onSubmitSuccess)
            .catch(this._onSubmitError)

    };

    _onSubmitSuccess = (response) => {
        swal({
            title: 'Descarga',
            html: 'La selección de Meter correctamente. Espere unos segundos por favor',
            type: 'success',
            showConfirmButton: false,
            timer: 3000
        });

        setTimeout(() => this.props.updateDischarge(response.data), 3000)
    };

    _onSubmitError = (error) => {
        this.setState({ajaxInProgress: false})
        try {
            let response = error.response
            if (response.status === 400) {
                let keys = Object.keys(response.data)
                let details = ''
                for (let i in keys) {
                    details = `${details} <p><b>${translator.getFieldName(keys[i])}:</b> ${response.data[keys[i]].join(' ')}</p>`
                }
                let body = `<div class='swal-container'><p>Se han encontrado los siguientes errores: </p>${details}</div>`
                swal({
                    title: 'No se ha podido crear la descarga',
                    html: body,
                    type: 'error'
                })
            } else {
                ajaxHandler(error)
            }
        }
        catch (e) {
            ajaxHandler(error)
        }
    };

    _goBack = () => {
        if(this.state.edited){
            swal({
                title: 'Atención',
                html: helpers.texts.editionWarning,
                type: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonText: 'Volver al inicio',
                cancelButtonText: 'Cancelar',
                preConfirm: () => this.props.history.push('/'),
                reverseButtons: true
            });
        }else{
            this.props.history.push('/')
        }

    };

    render () {
        let {trip, discharge} = this.state;
        if (!trip || !discharge) return <div/>

        // If there's an ajax call in progress or if user can not edit
        let disableButtons = (this.state.ajaxInProgress || !this.state.canEdit)

        return (
            <div>
                <div className={'discharge-title-section margin-bottom-5'}>
                    <i className={"material-icons icon-check"}>check</i>
                    Controles Previos
                </div>
                <div className={'discharge-title-section'}>Selección de Meter</div>
                <div className={'row'} >
                    <div className={'col s3 input-field'}>
                        <label className="active">Operador</label>
                        <p className={"field-p"}>
                            {discharge.unload_operator.first_name} {discharge.unload_operator.last_name}
                        </p>
                    </div>
                    <div className={'col s3 input-field'}>
                        <label className="active">Turno</label>
                        <p className={"field-p"}>
                            {discharge.unload_operator_shift}
                        </p>
                    </div>
                    <div className={'col s6 input-field'}>
                        <label className="active">Meter</label>
                        <select defaultValue={this.state.meter}
                                data-state-var="meter"  ref={ref => {this.meterSelect = ref}}>
                            {this.state.meters && this.state.meters.length > 1 &&
                                <option value="">Seleccione un meter</option>
                            }
                            {this.state.meters && this.state.meters.map(meter => {
                                return (
                                    <option key={meter.id} id={meter.id} value={meter.id}>
                                        {meter.loading_island.name} - {meter.description}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
                <div className={'row center'}>
                    <div className={'col s12'}>
                        <button onClick={this._goBack}
                              className={`btn btn-shell-empty z-depth-0 text-center ${disableButtons ? 'disabled' : ''}`}>
                            Volver
                        </button>
                        <button onClick={this._submitForm}
                                className={`btn btn-shell z-depth-0 text-center ${disableButtons ? 'disabled' : ''}`}>
                            Continuar
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(DischargeMeterSelection);


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/Discharge/DischargeMeterSelection.js